module.exports = __webpack_public_path__ + "static/media/1 home.bb3fbe37.png";